import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import uiConfig from '../data/uiConfig'

interface FooterProps {
  hideLogo?: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  hideLogo = false,
}) => {

  const txtColor = uiConfig.footer.color;
  const bgColor = uiConfig.footer.bgColor;
  const hoverColor = uiConfig.footer.hover;

  return (
    <footer className={`${bgColor} ${txtColor} py-4 mt-auto relative`}>
      <div className="mx-4 md:mx-body">
        <div className="flex justify-between items-center">
          {/* Logo Section */}
          {!hideLogo && (
            <div className="flex">
              <img src={'/logo.svg'} alt="Logo du site" className="h-14" />
            </div>
          )}

          <div>
            Le Rucher de Carole et Sylvain
          </div>
        </div>

        <div className={`mt-4 pt-4 border-t flex flex-col md:flex-row justify-between items-center`}>
          <p>&copy; {new Date().getFullYear()} Tous droits réservés</p>
          {/* Legal Links */}
          <div className="flex flex-row gap-4">
            <Link to="/faq" className={hoverColor}>FAQ</Link>
            <Link to="/informations-legales" className={hoverColor}>Informations légales</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};